import React from 'react';
import { SectionPanel } from 'ui';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlGroupsSectionType } from '../metroline/types';
import { ExternalUrlContainerProps } from 'app/area/external-url-groups/form/types-store';
import { ExternalUrl } from 'app/area/external-url-groups/form/components/external-url';

export const ExternalUrlContainer: React.FC<ExternalUrlContainerProps> = ({
  externalUrls, fetchingAddExternalUrls, externalUrlOptions, locale, externalUrlsValidation,
  translation, section, loadExternalUrlOptions, addExternalUrls, updateExternalUrl,
  deleteExternalUrl, deleteAllExternalUrls, updateValidation, displayError,
  getRef, shouldRenderSection
}) => {

  return <MetroLineSection<ExternalUrlGroupsSectionType>
    section={section}
    sectionType={ExternalUrlGroupsSectionType.ExternalUrls}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlGroupsSectionType.ExternalUrls)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlGroupsSectionType.ExternalUrls}
        validation={undefined}
        info={{ text: translation.external_urls_title }}
        label={{ visible: true, text: translation.external_urls_title }} />
      <ExternalUrl
        externalUrls={externalUrls}
        addExternalUrls={addExternalUrls}
        updateExternalUrl={updateExternalUrl}
        deleteExternalUrl={deleteExternalUrl}
        deleteAllExternalUrls={deleteAllExternalUrls}
        fetchingAddExternalUrls={fetchingAddExternalUrls}
        updateValidation={updateValidation}
        displayError={displayError}
        externalUrlOptions={externalUrlOptions}
        loadExternalUrlOptions={loadExternalUrlOptions}
        externalUrlsValidation={externalUrlsValidation}
        translation={translation}
        locale={locale} />
    </div>
  </MetroLineSection>;
};
